import React, { Component } from 'react';
import i18n from '../../i18n';
import { SelectBox } from 'devextreme-react';
import { ACTIVE_STATE } from '../../constants/Config';
import PropTypes from 'prop-types';

class ActiveSelectBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: {}
        };

        this.onDataChanged = this.onDataChanged.bind(this);
    }

    componentDidMount() {
        this.handleLanguage();
    }

    handleLanguage = () => {
        const { languages } = this.props;

        let datas = [];

        languages.forEach(element => {
            const newArray = [];

            for (const item of ACTIVE_STATE) {
                const i = Object.assign({}, item);
                const nameParse = (i.name ? JSON.parse(i.name) : '');

                i.name = nameParse[element.languageId];
                newArray.push(i);
            }

            datas = { ...datas, [element.languageId]: newArray };
        });

        this.setState({
            datas
        });
    }

    onDataChanged(e) {
        const { field } = this.props;

        this.props.updateData({
            [field]: e.value
        });
        if (e.value === null) {
            const { field } = this.props;

            this.props.updateData({
                [field]: ''
            });
        }
    }

    render() {
        const { currentLanguage, value, width, i18nLabel } = this.props;
        const { datas } = this.state;

        return (
            <div className="form-group cm-mgr-5">
                <div className={'dx-field'}>
                    <SelectBox
                        searchEnabled={true}
                        items={datas[currentLanguage]}
                        value={value}
                        valueExpr={'id'}
                        displayExpr={'name'}
                        placeholder={i18nLabel ? i18n.t(i18nLabel) : i18n.t('general.placeholder.Selectstatus')}
                        showClearButton={true}
                        onValueChanged={this.onDataChanged}
                        width={width || null}
                    />
                </div>
            </div>
        );
    }
}

ActiveSelectBox.propTypes = {
    currentLanguage: PropTypes.string,
    value: PropTypes.number,
    width: PropTypes.any,
    i18nLabel: PropTypes.string,
    languages: PropTypes.array,
    field: PropTypes.string,
    updateData: PropTypes.func
};

export default ActiveSelectBox;
